export default __webpack_public_path__ + "static/media/Industry_Phone.09877a5c.jpg";